import { useState } from 'react'
import axios from 'axios'
import { Modal, Select, message } from 'antd'

const EditPresentationApplication = (props) => {
    const [formValue, setFormValue] = useState({})
    const [campusList, setCampusList] = useState([])
    const [dateList, setDateList] = useState([])
    const [timeRangeList, setTimeRangeList] = useState([])
    const [venueList, setVenueList] = useState([])

    const getSlots = async (params = {}) => {
        const res = await axios.post('/client/presentation/slots', params)
        if (res.errcode === 0) {
            const { campus_list, date_list, time_range_list, venue_list } = res.data
            setCampusList(campus_list || [])
            setDateList(date_list || [])
            setTimeRangeList(time_range_list || [])
            setVenueList(venue_list || [])
        } else {
            message.error(res.msg || '获取时段数据失败')
        }
    }

    const campusOptions = campusList.map(item => ({
        label: item === 1 ? '兰州职业技术学院' : item === 2 ? '兰州职业技术学院（雁儿湾校区）' : item === 3 ? '兰州职业技术学院（桃林校区）' : item,
        value: item
    }))

    const dateOptions = dateList.map(item => ({
        label: item,
        value: item
    }))

    const timeOptions = timeRangeList.map(item => ({ 
        label: item, 
        value: item 
    }))
    
    const venueOptions = venueList.map(item => ({ 
        label: item.venue_name, 
        value: item.event_slot_id,
        disabled: item.status === 2
    }))

    // 选择校区
    const handleCampusChange = (value) => {
        setFormValue(prev => ({
            ...prev,
            campus: value,
            date: undefined,
            time_range: undefined,
            event_slot_id: undefined
        }))
        // 根据校区查询可用日期
        getSlots({ campus: value })
    }

    // 选择日期
    const handleDateChange = (value) => {
        setFormValue(prev => ({
            ...prev,
            date: value,
            time_range: undefined,
            event_slot_id: undefined
        }))
        // 根据校区+日期查询可用时段
        getSlots({
            campus: formValue.campus,
            date: value
        })
    }

    // 选择时段
    const handleTimeChange = (value) => {
        setFormValue(prev => ({
            ...prev,
            time_range: value,
            event_slot_id: undefined
        }))
        // 根据校区+日期+时段查询可用场地
        getSlots({
            campus: formValue.campus,
            date: formValue.date,
            time_range: value
        })
    }

    // 选择场地（直接拿到 event_slot_id）
    const handleVenueChange = (value) => {
        setFormValue(prev => ({
            ...prev,
            event_slot_id: value
        }))
    }

    const handleOk = async () => {
        const { campus, date, time_range, event_slot_id } = formValue
        if (!campus) {
            message.warning('请选择校区')
            return
        }
        if (!date) {
            message.warning('请选择日期')
            return
        }
        if (!time_range) {
            message.warning('请选择时段')
            return
        }
        if (!event_slot_id) {
            message.warning('请选择场地')
            return
        }

        axios.post('/admin/campus_presentation/update_slot', {
            application_id: props.data.application_id,
            event_slot_id: formValue.event_slot_id 
        })
            .then(function (response) {
                if (response.errcode === 0) {
                    message.success('重选完成！')
                    props.isCancel()
                    props.getPresentationDetail()
                    props.getApplicationData()
                } else {
                    message.error(response.msg)
                }
            })
            .catch(function (error) {
                console.error('请求失败，错误信息为：', error)
            })
    }


    return (
        <Modal
            title="重选预约资源"
            open={props.isOpen}
            onCancel={props.isCancel}
            onOk={handleOk}
            width={500}
        >
            {/* 校区 */}
            <div style={{ marginBottom: 15 }}>
                <div>校区</div>
                <Select
                    style={{ width: '100%' }}
                    value={formValue.campus}
                    options={campusOptions}
                    onChange={handleCampusChange}
                    onFocus={() => getSlots()} 
                />
            </div>

            {/* 日期 */}
            <div style={{ marginBottom: 15 }}>
                <div>日期</div>
                <Select
                    style={{ width: '100%' }}
                    value={formValue.date}
                    options={dateOptions}
                    disabled={!formValue.campus}
                    onChange={handleDateChange}
                />
            </div>

            {/* 时段 */}
            <div style={{ marginBottom: 15 }}>
                <div>时段</div>
                <Select
                    style={{ width: '100%' }}
                    value={formValue.time_range}
                    options={timeOptions}
                    disabled={!formValue.date}
                    onChange={handleTimeChange}
                />
            </div>

            {/* 场地 */}
            <div style={{ marginBottom: 15 }}>
                <div>场地</div>
                <Select
                    style={{ width: '100%' }}
                    value={formValue.event_slot_id}
                    options={venueOptions}
                    disabled={!formValue.time_range}
                    onChange={handleVenueChange}
                    showSearch
                    optionFilterProp="label"
                />
            </div>
        </Modal>
    )
}

export default EditPresentationApplication